export default __webpack_public_path__ + "static/media/img_office_kako.31d91a2c.svg";